import React from 'react';
import ItemIdMap from '../../../Interfaces/Reports/ItemIdMap';
import DataSetItem from './DataSetItem';
import ChartItem from './ChartItem';
import NoDataItem from './NoDataItem';
import ChartJSChartData from '../../../Interfaces/Responses/Reports/Charts/ChartData';
import AgGridJSRowData from '../../../Interfaces/Responses/Reports/DataSets/DataSetData';

interface ReportItemProps extends ItemIdMap {
    handleRowClick: (
        dataSetIndex: number,
        index: number,
        rowData: any,
        gridData: AgGridJSRowData
    ) => void | undefined;
    handleBarClick: (
        dataSetIndex: number,
        index: number,
        chartData: ChartJSChartData
    ) => void | undefined;
}

const ReportItem = ({ type, ...props }: ReportItemProps) => {
    // ---- DEBUG
    // console.log('**** RIPs ****');
    // console.log(type);
    // console.log(props);
    // ---- END DEBUG
    switch (type)
    {
        case 'grid':
            return <DataSetItem type="grid" {...props} />;

        case 'chart':
            return <ChartItem type="chart" {...props} />;

        default:
            return <NoDataItem type="noData" {...props} />;
    }
};

export default ReportItem;
